import { render, staticRenderFns } from "./MessageDetails.vue?vue&type=template&id=e8e07b70&"
import script from "./MessageDetails.vue?vue&type=script&lang=js&"
export * from "./MessageDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8e07b70')) {
      api.createRecord('e8e07b70', component.options)
    } else {
      api.reload('e8e07b70', component.options)
    }
    module.hot.accept("./MessageDetails.vue?vue&type=template&id=e8e07b70&", function () {
      api.rerender('e8e07b70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/MessageDetails.vue"
export default component.exports